import { render, staticRenderFns } from "./VoucherList.vue?vue&type=template&id=20dfc79c&scoped=true&"
import script from "./VoucherList.vue?vue&type=script&lang=ts&"
export * from "./VoucherList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dfc79c",
  null
  
)

export default component.exports